import { render, staticRenderFns } from "./multipleUpload.vue?vue&type=template&id=237a7cab&scoped=true&"
import script from "./multipleUpload.vue?vue&type=script&lang=js&"
export * from "./multipleUpload.vue?vue&type=script&lang=js&"
import style0 from "./multipleUpload.vue?vue&type=style&index=0&id=237a7cab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a7cab",
  null
  
)

export default component.exports